import React from 'react'
import CIcon from '@coreui/icons-react'
import { cibFlipboard, cibPinboard, cilBell, cilCalculator, cilCalendar, cilChartPie, cilClipboard, cilCode, cilCursor, cilDescription, cilDrop, cilLevelUp, cilList, cilNoteAdd, cilNotes, cilOptions, cilPencil, cilPuzzle, cilSpeedometer, cilStar, cilTruck, cilUser, } from '@coreui/icons'
import { CNavGroup, CNavItem, CNavTitle } from '@coreui/react'

const PartnersSideBarNavData = [
  {
    component: CNavItem,
    name: '홈',
    to: '.',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />
  },
  {
    component: CNavTitle,
    name: '스토어',
  }, {
    component: CNavItem,
    name: '스토어 등록',
    to: 'store/register',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: '스토어 관리',
    to: 'store/sales',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  },

  {
    component: CNavTitle,
    name: '상품',
  },

  {
    component: CNavItem,
    name: '상품 목록',
    to: 'product/list',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: '상품 등록',
    to: 'product/register',
    icon: <CIcon icon={cilNoteAdd} customClassName="nav-icon" />,
  },
  {
    component: CNavTitle,
    name: '카테고리',
  },
  {
    component: CNavItem,
    name: '카테고리 생성',
    to: 'category/create',
    icon: <CIcon icon={cilNoteAdd} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: '카테고리 관리',
    to: 'category/register',
    icon: <CIcon icon={cilNoteAdd} customClassName="nav-icon" />,
  },
  {
    component: CNavTitle,
    name: '브랜드',
  },
  {
    component: CNavItem,
    name: '브랜드 등록',
    to: 'brand/register',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: '브랜드 관리',
    to: 'brand/list',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  },

  {
    component: CNavTitle,
    name: '자판기',
  },
  {
    component: CNavItem,
    name: '기기 등록',
    to: 'vending/register',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: '기기 관리',
    to: 'vending/management',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: '기기 매핑',
    to: 'vending/mapping',
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  }

]
export default PartnersSideBarNavData;
